// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
import { getDefaultSlots } from '@progress/kendo-vue-common';
import { cardActionsLayout, cardOrientation } from './interfaces/Enums';
/**
 * Represents the default `CardActions` component.
 */

var CardActionsVue2 = {
  name: 'KendoCardActions',
  props: {
    layout: {
      type: String,
      default: cardActionsLayout.START,
      validator: function validator(value) {
        return ['stretched', 'start', 'center', 'end'].includes(value);
      }
    },
    orientation: {
      type: String,
      default: cardOrientation.HORIZONTAL,
      validator: function validator(value) {
        return ['horizontal', 'vertical'].includes(value);
      }
    }
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },
  computed: {
    wrapperClass: function wrapperClass() {
      var _a;

      return _a = {
        'k-card-actions': true
      }, _a["k-card-actions-" + this.$props.layout] = true, _a["k-card-actions-" + (this.$props.orientation !== cardOrientation.HORIZONTAL ? 'vertical' : 'k-card-horizontal')] = true, _a;
    }
  },
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlots = getDefaultSlots(this);
    return h("div", {
      "class": this.wrapperClass
    }, [defaultSlots]);
  }
};
var CardActions = CardActionsVue2;
export { CardActions, CardActionsVue2 };